export default {
  data() {
    return {
      suggestionHighlightIndex: -1,
    };
  },
  watch: {
    suggestions() {
      this.resetSuggestionHighlight();
    },
  },
  methods: {
    resetSuggestionHighlight() {
      this.suggestionHighlightIndex = -1;
    },
    getSuggestionListId(rowIndex) {
      const rowPart =
        rowIndex !== undefined && rowIndex !== null ? `${rowIndex}` : "popup";
      return `symbol-suggestion-list-${rowPart}`;
    },
    getSuggestionOptionId(rowIndex, sugIndex) {
      const rowPart =
        rowIndex !== undefined && rowIndex !== null ? `${rowIndex}` : "popup";
      return `symbol-suggestion-${rowPart}-${sugIndex}`;
    },
    prepareSymbolAutofill(rowIndex) {
      this.doAutoSuggest = true;
      if (rowIndex !== undefined && rowIndex !== null) {
        this.symIndex = rowIndex;
        this.sugCurIndex = rowIndex;
      }
    },
    handleSymbolRowInput(index, event) {
      this.prepareSymbolAutofill(index);
      this.updateJson(index, event, "Symbol");
    },
    handleSymbolPopupInput(event) {
      this.doAutoSuggest = true;
      this.updateJsonResponsive(event, "Symbol");
    },
    isSymbolSuggestionListOpen(rowIndex) {
      if (!this.doAutoSuggest || !this.suggestions.length) {
        return false;
      }
      if (rowIndex !== undefined && rowIndex !== null) {
        return this.symIndex === rowIndex || this.sugCurIndex === rowIndex;
      }
      return true;
    },
    onSymbolSuggestionKeydown(event, rowIndex) {
      if (!this.isSymbolSuggestionListOpen(rowIndex)) {
        return;
      }
      const { key } = event;
      if (key === "ArrowDown") {
        event.preventDefault();
        if (this.suggestionHighlightIndex < this.suggestions.length - 1) {
          this.suggestionHighlightIndex += 1;
        } else if (this.suggestionHighlightIndex < 0) {
          this.suggestionHighlightIndex = 0;
        }
        this.focusSuggestionOption(rowIndex, this.suggestionHighlightIndex);
      } else if (key === "ArrowUp") {
        event.preventDefault();
        if (this.suggestionHighlightIndex > 0) {
          this.suggestionHighlightIndex -= 1;
        } else {
          this.suggestionHighlightIndex = 0;
        }
        this.focusSuggestionOption(rowIndex, this.suggestionHighlightIndex);
      } else if (key === "Enter") {
        event.preventDefault();
        const selectedIndex =
          this.suggestionHighlightIndex >= 0
            ? this.suggestionHighlightIndex
            : 0;
        const item = this.suggestions[selectedIndex];
        if (item) {
          this.selectSuggestionFromOption(rowIndex, item);
        }
      } else if (key === "Escape") {
        event.preventDefault();
        this.suggestions = [];
        this.doAutoSuggest = false;
        this.resetSuggestionHighlight();
      }
    },
    onSuggestionOptionKeydown(event, rowIndex, sugIndex) {
      if (!this.isSymbolSuggestionListOpen(rowIndex)) {
        return;
      }
      const { key } = event;
      if (key === "ArrowDown") {
        event.preventDefault();
        this.suggestionHighlightIndex = Math.min(
          sugIndex + 1,
          this.suggestions.length - 1
        );
        this.focusSuggestionOption(rowIndex, this.suggestionHighlightIndex);
      } else if (key === "ArrowUp") {
        event.preventDefault();
        this.suggestionHighlightIndex = Math.max(sugIndex - 1, 0);
        this.focusSuggestionOption(rowIndex, this.suggestionHighlightIndex);
      } else if (key === "Enter") {
        event.preventDefault();
        this.selectSuggestionFromOption(
          rowIndex,
          this.suggestions[sugIndex]
        );
      } else if (key === "Escape") {
        event.preventDefault();
        this.suggestions = [];
        this.doAutoSuggest = false;
        this.resetSuggestionHighlight();
        event.target.blur();
      }
    },
    focusSuggestionOption(rowIndex, sugIndex) {
      this.$nextTick(() => {
        const el = document.getElementById(
          this.getSuggestionOptionId(rowIndex, sugIndex)
        );
        if (el) {
          el.focus();
        }
      });
    },
    selectSuggestionFromOption(rowIndex, suggitem) {
      if (rowIndex !== undefined && rowIndex !== null) {
        this.updateSuggestion(rowIndex, suggitem, "Symbol");
      } else {
        this.updateSuggestionResponsive(suggitem, "Symbol");
      }
      this.resetSuggestionHighlight();
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/symbolSuggestionKeyboard.js